import * as activity from './activity';
import * as cards from './cards';
import * as channel from './channel';
import * as chat from './chat';
import * as thread from './thread';
import * as workflow from './workflow';

export const Subscriptions = { channel, chat, thread, cards, activity, workflow };
